import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const footerTestimonials = [{
  name: 'Dra. Sofía G.',
  role: 'R1, La Plata',
  text: 'El capítulo de fracturas de miembro inferior es una locura. Entendí la clasificación de Schatzker en 5 minutos viendo los esquemas. Imprescindible.'
}, {
  name: 'Dr. Martín V.',
  role: 'Médico de Guardia, Mendoza',
  text: 'Compré la versión PRO y el manual de semiología vale cada peso. Me dio la seguridad que me faltaba para evaluar rodillas agudas a las 4 AM.'
}, {
  name: 'Dra. Florencia C.',
  role: 'R2, Tucumán',
  text: 'Los algoritmos de guardia nocturna los tengo impresos en el bolsillo del ambo. Me salvaron de despertar a mi jefe de guardia más de una vez.'
}, {
  name: 'Dr. Lautaro B.',
  role: 'R1, Mar del Plata',
  text: 'El ABCDE en trauma está explicado para que lo apliques, no para que lo recites en un examen. Práctico, directo y visual.'
}, {
  name: 'Dra. Camila R.',
  role: 'R1, Salta',
  text: 'Tenía terror a las luxaciones. Con la guía de qué imágenes pedir pre y post reducción, ahora encaro esos pacientes con total tranquilidad.'
}];
export function FooterTestimonials() {
  return <section className="py-16 bg-pastel-50 px-4" data-id="element-75">
      <div className="max-w-6xl mx-auto" data-id="element-76">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-navy-900 mb-10" data-id="element-77">
          Más residentes que ya optimizaron sus guardias
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-78">
          {footerTestimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={`bg-white p-6 rounded-2xl shadow-sm border border-pastel-200 ${i > 2 ? 'lg:col-span-1' : ''}`} data-id="element-79">
              <div className="flex text-gold-500 mb-3" data-id="element-80">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-81" />)}
              </div>
              <p className="text-slate-600 text-sm italic mb-4" data-id="element-82">"{t.text}"</p>
              <div className="flex items-center gap-3" data-id="element-83">
                <div className="w-8 h-8 bg-navy-100 rounded-full flex items-center justify-center text-navy-800 font-bold text-xs" data-id="element-84">
                  {t.name.charAt(4)}
                </div>
                <div data-id="element-85">
                  <p className="font-bold text-navy-900 text-xs" data-id="element-86">{t.name}</p>
                  <p className="text-slate-500 text-[10px]" data-id="element-87">{t.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}